<template>
  <burger-menu :links="links">
    <template v-slot:items>
      <burger-menu-authorize-items />
    </template>
    <template v-slot:actions>
      <burger-menu-authorize-actions />
    </template>
  </burger-menu>
</template>

<script>
import BurgerMenu from '@/components/header/BurgerMenu.vue';
import BurgerMenuAuthorizeItems from '@/components/header/BurgerMenuAuthorizeItems.vue';
import BurgerMenuAuthorizeActions from '@/components/header/BurgerMenuAuthorizeActions.vue';

export default {
  components: {
    BurgerMenu,
    BurgerMenuAuthorizeItems,
    BurgerMenuAuthorizeActions,
  },
  props: {
    links: Array,
  },
};
</script>
